import React from 'react';
import AddToCartButton from '../AddToCartButton';

const ProductCard = ({
  product,
  isAdminView = false,
  onEdit = null,
  onDelete = null,
  onClick = null
}) => {
  const handleCardClick = () => {
    if (onClick && !isAdminView) {
      onClick(product);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  };

  return (
    <div 
      className={`product-card ${onClick && !isAdminView ? 'clickable' : ''}`}
      onClick={handleCardClick}
      style={{
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '16px',
        margin: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        cursor: onClick && !isAdminView ? 'pointer' : 'default',
        transition: 'transform 0.2s, box-shadow 0.2s'
      }}
      onMouseEnter={(e) => {
        if (onClick && !isAdminView) {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick && !isAdminView) {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        }
      }}
    >
      {/* Product Image */}
      <div style={{ marginBottom: '12px', textAlign: 'center' }}>
        <img 
          src={'https://placehold.co/200x150/f0f0f0/888888?text=Auto+Part'} 
          alt={product.name}
          style={{
            width: '100%',
            height: '150px',
            objectFit: 'cover',
            borderRadius: '4px',
            backgroundColor: '#f5f5f5'
          }}
        />
      </div>
      
      {/* Product Info */}
      <div style={{ marginBottom: '8px' }}>
        <h3 style={{ 
          margin: '0 0 8px 0',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#333',
          lineHeight: '1.3'
        }}>
          {product.name}
        </h3>
        
        <p style={{ 
          margin: '0 0 4px 0',
          fontSize: '14px',
          color: '#666',
          textTransform: 'capitalize'
        }}>
          {product.category}
        </p>
        
        {product.brand && (
          <p style={{ 
            margin: '0 0 8px 0',
            fontSize: '12px',
            color: '#888',
            fontStyle: 'italic'
          }}>
            {product.brand}
          </p>
        )}
        
        {product.partNumber && (
          <p style={{ 
            margin: '0 0 8px 0',
            fontSize: '12px',
            color: '#666',
            fontFamily: 'monospace'
          }}>
            Part #: {product.partNumber}
          </p>
        )}
      </div>
      
      {/* Price */}
      <div style={{ marginBottom: '12px' }}>
        <span style={{
          fontSize: '20px',
          fontWeight: 'bold',
          color: '#2c5aa0'
        }}>
          {formatPrice(product.price)}
        </span>
      </div>
      
      {/* Stock Indicator */}
      <div style={{ marginBottom: '12px' }}>
        <span 
          style={{
            display: 'inline-block',
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: 'bold',
            backgroundColor: product.stockQuantity > 0 ? '#d4edda' : '#f8d7da',
            color: product.stockQuantity > 0 ? '#155724' : '#721c24'
          }}
        >
          {product.stockQuantity > 0 
            ? `${product.stockQuantity} in stock` 
            : 'Out of stock'
          }
        </span>
      </div>
      
      {/* User Actions - Add to Cart */}
      {!isAdminView && (
        <div style={{ 
          marginTop: '12px',
          borderTop: '1px solid #eee',
          paddingTop: '12px'
        }}>
          <AddToCartButton 
            product={product}
            showQuantitySelector={true}
            className="product-add-to-cart"
          />
        </div>
      )}

      {/* Admin Actions */}
      {isAdminView && (
        <div style={{ 
          display: 'flex', 
          gap: '8px',
          marginTop: '12px',
          borderTop: '1px solid #eee',
          paddingTop: '12px'
        }}>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onEdit(product.id);
            }}
            style={{
              flex: 1,
              padding: '6px 12px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            Edit
          </button>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onDelete(product.id);
            }}
            style={{
              flex: 1,
              padding: '6px 12px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductCard;